import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';

export default function OptionValidator({ name = '' }) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="w-100">
      <Controller
        name={name}
        control={control}
        rules={{ validate: (val) => val?.length > 0 }}
        render={({ field }) => <input ref={field.ref} type="hidden" />}
      />
      <RequiredValidation field={name} errors={errors} message="Atleast one option need to be added. Please check field settings." />
    </div>
  );
}
